"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.homeRoutes = void 0;
exports.homeRoutes = [
    {
        name: 'home:index',
        path: ['/', '*frontRoute'],
        method: 'GET',
        priority: -10
    },
    {
        name: 'home:pay-confirm',
        path: ['/payment-confirm'],
        method: 'GET'
    },
    {
        name: 'home:share',
        path: ['/share/{:uid}'],
        method: 'GET'
    },
    {
        name: 'home:reset-pass',
        path: ['/reset-password/{:token}'],
        method: 'GET'
    },
    {
        name: 'home:activate',
        path: ['/activate-account/{:token}'],
        method: 'GET'
    },
    {
        name: 'home:image',
        path: '/image/*path',
        method: 'GET',
        priority: -9
    },
    {
        name: 'home:alive',
        path: '/api/alive',
        method: 'GET'
    },
    {
        name: 'home:public-file',
        path: '/uploads/public/{:filePath}',
        method: 'GET'
    },
    {
        name: 'home:file',
        path: '/uploads/{:filePath}',
        method: 'GET'
    }
];
